import request from '@/utils/request'


export function list(query) {
    return request({
        url: '/area/list',
        method: 'post',
        data: query
    })
}

export function goodsList() {
    return request({
        url: '/mallGoods/goodsList',
        method: 'get'
    })
}


export function userList() {
    return request({
        url: '/user/list',
        method: 'get'
    })
}

export function info(id) {
    return request({
        url: '/area/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/area/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/area/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/area/delete',
        method: 'post',
        data
    })
}

